import { DataTypeProvider } from '@devexpress/dx-react-grid';
import React from 'react';
import { numberFilterOperations } from '../../NRReactGrid/NRReactGrid.utils';
import NRSeverityLabel from '../../NRSeverityLabel/NRSeverityLabel';

function NRSeverityFormatter({ value, row }) {
  return <NRSeverityLabel severity={value} cvssScore={row?.cvssScore} />;
}

export const NRSeverityProvider = props => (
  <DataTypeProvider formatterComponent={NRSeverityFormatter} availableFilterOperations={numberFilterOperations} {...props} />
);
